import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { BaseComponent } from '../base';


export interface ConfirmationConfig {
	title?: string;
	message?: string;
	isCancelBtn?: boolean;
	cancelBtn?: string;
	confirmBtn?: string;
}


/**
 * Modal component to confirm an action.
 */
@Component({
	selector: 'app-confirmation',
	templateUrl: './confirmation.component.html',
	changeDetection: ChangeDetectionStrategy.Eager
})
export class ConfirmationComponent extends BaseComponent implements OnInit {

	public activeModal = inject(NgbActiveModal);
	public config?: ConfirmationConfig;

	ngOnInit(): void {
		this.config = { isCancelBtn: true, ...this.config };
	}

}